/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-19 10:44:37
 */
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { DtBrowserModule } from '@ithinkdt/shared/browser';

import { PcpThemeAccountComponent } from './pcp-theme-account/pcp-theme-account.component';
import { PcpThemeLogoComponent } from './pcp-theme-logo/pcp-theme-logo.component';
import { PcpThemeMenuComponent } from './pcp-theme-menu/pcp-theme-menu.component';
import { PcpThemeUserPanelComponent } from './pcp-theme-user/pcp-theme-user-panel/pcp-theme-user-panel.component';
import { PcpThemeUserComponent } from './pcp-theme-user/pcp-theme-user.component';
import { PcpThemeComponent } from './pcp-theme.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DragDropModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [
  NzDrawerModule,
  NzModalModule,
  NzDropDownModule,
  NzPopoverModule,
  NzBadgeModule,
  NzTabsModule,
  NzListModule,
  NzInputModule,
  NzIconModule,
  NzButtonModule,
  NzFormModule,
  NzAvatarModule,
  NzMenuModule,
  NzToolTipModule,
  NzLayoutModule,
  NzDividerModule,
  NzSelectModule,
  NzSwitchModule,
  NzSpinModule,
  NzTagModule,
];

const DT_MODULES = [DtBrowserModule];

const COMPONENTS = [
  PcpThemeComponent,
  PcpThemeUserComponent,
  PcpThemeLogoComponent,
  PcpThemeMenuComponent,
  PcpThemeAccountComponent,
  PcpThemeUserPanelComponent,
];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, ...DT_MODULES],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DtPcpThemeModule {}
